<template>
    <div class="pdfCom">
        <div style="display: flex;justify-content: center" id="flipbook">
            <canvas :id="'canvas' + item" v-for="item in pdfHTML" :key="item" />
        </div>
        <div  :class="{btn:true, appBtn: flag == 'app'  }"  v-if="pagesTotalNum">
            <!-- 添加 disabled 属性控制按钮状态 -->
            <el-button size="mini" @click="shang()" :disabled="page <= 1">上一页</el-button>
            {{ page }} / {{ pagesTotalNum }}
            <el-button size="mini" @click="xia()" :disabled="page >= pagesTotalNum">下一页</el-button>
        </div>
    </div>
</template>


<script>
const PDFJS = require("pdfjs-dist");
PDFJS.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.min");
import "@/assets/js/turn.min.js";

export default {
    props: {
        pdfUrl: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            pdfDoc: null,
            pdfHTML: 0,
            page: 1,
            pagesTotalNum: 0,
            flag: 'pc',
            renderedPages: new Set(),
            currentRange: { start: 1, end: 20 }
        };
    },
    methods: {
        init(fileUrl) {
            let _this = this;
            PDFJS.getDocument(fileUrl).then((fileContent) => {
                _this.pdfDoc = fileContent;
                _this.pagesTotalNum = fileContent.numPages;
                _this.pdfHTML = fileContent.numPages;
                
                setTimeout(() => {
                    _this.renderPage(1, 20);
                    let w = $("body").width() - 400;
                    let h = $("body").height() - 120;
                    let turnW = (h / 1.4) * 2;
                    
                    if (w < turnW) {
                        turnW = w;
                        h = (w / 2) * 1.4;
                    }
                    
                    $(".btn").css("width", turnW + "px");
                    
                    if(this.flag === 'app' && turnW < 200) {
                        turnW = 250;
                        h = 200;
                        $(".btn").css("width", "270px");
                    }
                    
                    $("#flipbook").turn({
                        width: turnW,
                        height: h,
                        autoCenter: true,
                        gradients: true,
                        pages: _this.pagesTotalNum,
                        page: _this.page,
                        when: {
                            turning: function(e, newPage, view) {
                                _this.page = newPage;
                                const newStart = Math.max(1, newPage - 10);
                                const newEnd = Math.min(_this.pagesTotalNum, newPage + 10);
                                _this.updateRenderRange(newStart, newEnd);
                                
                                if (newPage !== 1) {
                                    $(`.even.p${view[0]}`).css("padding-right", "20px");
                                    $(`.odd.p${view[0] + 1}`).css("padding-left", "20px");
                                }
                            }
                        }
                    });
                }, 100);
            });
        },

        updateRenderRange(start, end) {
            // 清空旧范围外的页面
            this.clearOutsideRange(start, end);
            // 渲染新范围内的页面
            this.renderPage(start, end);
            this.currentRange = { start, end };
        },

        renderPage(start, end) {
            for (let pageNum = start; pageNum <= end; pageNum++) {
                if (this.renderedPages.has(pageNum)) continue;
                
                const canvas = document.getElementById(`canvas${pageNum}`);
                if (!canvas) continue;

                const ctx = canvas.getContext("2d");
                this.pdfDoc.getPage(pageNum).then(page => {
                    const viewport = page.getViewport(2);
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    
                    const renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    
                    page.render(renderContext).then(() => {
                        this.renderedPages.add(pageNum);
                    });
                });
            }
        },

        clearOutsideRange(start, end) {
            for (let pageNum = 1; pageNum <= this.pagesTotalNum; pageNum++) {
                if (pageNum >= start && pageNum <= end) continue;
                
                const canvas = document.getElementById(`canvas${pageNum}`);
                if (!canvas) continue;

                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                canvas.width = 0;
                canvas.height = 0;
                this.renderedPages.delete(pageNum);
            }
        },

        shang() {
            if (this.page > 1) {
                $("#flipbook").turn("previous"); 
            }
        },

        xia() {
            if (this.page < this.pagesTotalNum) {
                $("#flipbook").turn("next");
            }
        }
    },
    mounted() {
        this.flag = sessionStorage.getItem("flag") || 'pc';
        const CMAP_URL = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/";
        this.init({
            url: this.pdfUrl,
            cMapUrl: CMAP_URL,
            cMapPacked: true
        });
    }
};
</script>
<style lang="less" scoped>
.pdfCom {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    .btn {
        width: 100%;
        position: absolute;
        bottom: -50px;
        left: 0;
    }
    .appBtn{
        width:270px !important;
    }
    #flipbook .shadow,
    #flipbook.shadow {
        -webkit-box-shadow: 0 4px 10px #666;
        -moz-box-shadow: 0 4px 10px #666;
        -ms-box-shadow: 0 4px 10px #666;
        -o-box-shadow: 0 4px 10px #666;
        box-shadow: 0 4px 10px #666;
    }
    
    .p1{
        // padding:0px !important;
        // background: #fff !important;
        // background-image: none !important;
    }
    .even,.odd{
        // background: var(--page-color);
        // padding: 30px 30px 30px 20px;

    }
    .even {
        background-image: url("../assets/img/gradient-page-left.jpg");
        background-position: right top;
        background-repeat: repeat-y;
    }
    
    .odd {
        background-image: url("../assets/img/gradient-page-right.jpg");
        background-position: left top;
        background-repeat: repeat-y;
    }
}
</style>
<style>
:root {
    --binding-width: 20px; /* 装订线宽度 */
    /* --page-color: #f7f2e3; */
 }
/* 左右页面 */
.page {
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: auto;
    border: 1px solid #d0c4b0; /*页面边框 */
}
</style>


// WEBPACK FOOTER //
// src/components/pdfjs.vue